import React from 'react';
import {
  Button, Row, Col, Input, Pagination, Table, Spin, Modal, message, DatePicker, Popconfirm
} from 'antd';
import {inject, observer} from 'mobx-react';
import AppDatasBody from '../util/AppDatasBody';
import {toJS} from 'mobx';
import base from '../../tool/base';
import util from '../../util/index';
import Detail from './Detail';
import EcodeApplyModal from './EcodeApplyModal';

const { RangePicker } = DatePicker;
const {
  catchApiError,
  getAccessToken,
  getRcId,
} = util;

const store = ['commonStore','ecodeOrderStore', 'ecodeDemoStore']
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'order-ecode',
  }  
  
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      ecodeVisible: false,
      appId: '',
    }
  }

  componentDidMount() {
    const { getApplyList } = this.props.ecodeOrderStore;
    getApplyList();
  }
  preview = record => {
    const { ecodeOrderStore: { setState } } = this.props;
    const applyTypeObj = {
      temporary: '临时',
      permanent: '永久',
    }
    const applyStatusObj = {
      successful: '通过',
      applying: '审核中',
      failed: '通过'
    }
    const applySourceObj = {
      ecode: 'ecode',
      cloudstore: '云商店'
    }
    let detail = {
      ...record,
      applyType: applyTypeObj[record.applyType],
      applyStatus: applyStatusObj[record.applyStatus],
      applySource: applySourceObj[record.applySource],
    }

    setState({detail});
    this.setState({visible: true});
  }
  onCancel = () => {
    // const { ecodeOrderStore: { setState } } = this.props;
    this.setState({visible: false});
  }
  temporaryAuth = appId => {
    this.setState({ecodeVisible: true, appId});
  }
  downlaod = id => {
    // message.loading({content: "下载中...", key: 'downlaod'});
    const url = `${window.server}/v5/ecode/downloadApp?id=${id}`;
    window.open(url);
    // const params = {
    //   id,
    //   access_token: getAccessToken(),
    // }
    // let timestamp=new Date().getTime();
    // base.callApi('/v5/ecode/downloadApp', 'GET', params, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
    //   if (data.status) {
    //     message.success({content: '成功', key: 'downlaod'});
    //   } else {
    //     message.error({content: data.msg, key: 'downlaod'});
    //   }
    // });
  }
  render() {
    const {
      prefixCls,
      location,
      dev,
      ecodeOrderStore: { getDevAuth, devAuthLoadingIds, ecodeDates, searchValue, pagination, setPagination, ecodeDatesCount, loadingOrder, setSearch, clearSearch, getApplyList },
      ecodeDemoStore: { approval },
    } = this.props;
    const { visible, ecodeVisible, appId } = this.state;
    const rcId = getRcId();
    const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    const columns = [
      {
        key: 'appName',
        title: '案例名称',
        dataIndex: 'appName',
        style: {maxWidth: 240},
        render: (text, record, index) => {
          return (
            <a onClick={() => this.preview(record)}>{text}</a>
          );
        }
      },
      {
        key: 'orderNumber',
        title: '订单号',
        dataIndex: 'orderNumber',
        width: 150,
        // render(text, record, index) {
         
        // }
      },
      {
        key: 'applyType',
        title: '授权类型',
        dataIndex: 'applyType',
        width: 120,
        render(text, record, index) {
          let status = "";
          switch(text) {
            case 'temporary': 
              status = '临时';
              break;
            case 'permanent': 
              status = '永久';
              break;
          }
          return status;
        }
      },
      {
        key: 'applyStatus',
        title: '申请状态',
        dataIndex: 'applyStatus',
        width: 150,
        render(text, record, index) {
          let status = "";
          switch(text) {
            case 'applying': 
              status = '审核中';
              break;
            case 'successful': 
              status = '已通过';
              break;
            case 'failed': 
              status = '未通过';
              break;
          }
          return status;
        }
      },
      {
        key: 'applicantName',
        dataIndex: 'applicantName',
        title: '申请人',
        width: 150,
      },
      {
        key: 'time',
        title: '申请时间',
        style: {minWidth: 150},
        render(text, record, index) {
          return (
            <div>
              <div className="order-ecode-statue">{record.createDate}</div>
              <div className="order-ecode-statue">{record.createTime}</div>
            </div>
          )
        }
      },
      {
        key: 'operation',
        title: '操作',
        width: 240,
        render: (text, record, index) => {
          const devDisable = devAuthLoadingIds.some(item => record.appId === item) && !record.authCode;
          return (
            <div>
              <span
                className={`order-ecode-operation ${record.authCode ? '' : 'disable' }`}
                onClick={() => {
                  record.authCode && Modal.info({
                    title: '授权码',
                    content: (
                      <div>
                        <p>{record.authCode ? record.authCode : '暂无'}</p>
                      </div>
                    ),
                  });
                }}
              >应用授权</span>
              <span
                className={`order-ecode-operation ${devDisable ? "disable" : ""}`}
                onClick={() => {

                  devDisable || getDevAuth(record.appId, { orderNum: record.orderNumber }, (data) => {
                    Modal.info({
                      title: '授权码',
                      content: (
                        <div>
                          <p>{data}</p>
                        </div>
                      ),
                    })
                  })
                }}
              >开发授权</span>
              <span
                className={`order-ecode-operation ${record.applyStatus === 'successful' ? '' : 'disable' }`}
                onClick={() => {
                  record.applyStatus === 'successful' && this.downlaod(record.id)
                }}
              >下载</span>
              {
                rcId >= 75 && (
                  <span
                    className="order-ecode-operation"
                    onClick={() => {
                    }}
                  >
                    <Popconfirm
                      key="applyingPass"
                      title='确认通过吗?'
                      okText="确定"
                      cancelText="取消"
                      onConfirm={() => {
                        let id = record.id;
                        approval(id, "successful");
                      }}>
                      <span>通过</span>
                    </Popconfirm>
                </span>
                )
              }
              {
                rcId >= 75 && (
                  <span
                    className="order-ecode-operation"
                    onClick={() => {
                    }}
                  >
                    <Popconfirm
                      key="applyingFail"
                      title='确认不通过吗?'
                      okText="确定"
                      cancelText="取消"
                      onConfirm={() => {
                        let id = record.id;
                        approval(id, "failed");
                      }}>
                      <span>不通过</span>
                    </Popconfirm>
                  </span>
                )
              }
            </div>
          );
        }
      }
    ];
    return (
      <div className={prefixCls}>
        <AppDatasBody location={location}>
          <div className="cs-search-mylist">
            <Row style={{padding: '0 16px'}}>
              <Col span={18}>
                <Row>
                  <Col span={3} style={{paddingTop: 5}}> <label>案例名称：</label> </Col>
                  <Col span={7}>
                    <Input style={{marginRight:10,width:'90%'}} placeholder='请输入案例名称'
                      value={searchValue.title}
                      onChange={(e) => {
                        setSearch({title: e.target.value});
                      }}
                      onPressEnter={() => {
                        getApplyList();
                      }}
                    />
                  </Col>
                  <Col span={7}>
                    <Input style={{marginRight:10,width:'90%'}} placeholder='请输入订单号'
                      value={searchValue.orderNumber}
                      onChange={(e) => {
                        setSearch({orderNumber: e.target.value});
                      }}
                      onPressEnter={() => {
                        getApplyList();
                      }}
                    />
                  </Col>
                  <Col span={7}>
                    <RangePicker
                      placeholder="请选择申请时间段"
                      placeholder={['申请时间(开始)', '申请时间(结束)']}
                      value={searchValue.applyDate || []}
                      format="YYYY-MM-DD"
                      onChange={(value, dateString) => {
                        setSearch({ applyDate: value, applyDateString: dateString });
                        getApplyList();
                      }}/>
                  </Col>
                  <Col span={7}>
                  </Col>
                </Row>
              </Col>
              <Col span={6}>
                <Col span={16} offset={8}>
                  <Button type="primary"
                    style={{marginRight:10}}
                    onClick={() => {
                      getApplyList();
                    }}
                  >
                    搜索
                  </Button>
                  <Button type="ghost"
                    onClick={() => {
                      clearSearch();
                    }}
                  >
                    重置
                  </Button>
                </Col>
              </Col>
            </Row>
            <div style={{marginTop: 20, minHeight: 600}}>
              <Spin spinning={loadingOrder}>
                <Table
                  columns={columns}
                  dataSource={toJS(ecodeDates)}
                  pagination={false}
                  rowKey="id"
                />
              </Spin>
            </div>
            <div style={{textAlign: 'right', paddingTop: 13}}>
              {
                ecodeDatesCount !== 0 && ecodeDates.length > 0 && 
                  <Pagination
                    defaultCurrent={1}
                    pageSize={pagination.pageSize}
                    current={pagination.pageNum}
                    total={ecodeDatesCount}
                    onChange={setPagination}
                    onShowSizeChange={(current, pageSize) => {
                      setPagination(1, pageSize)
                    }}
                    showTotal={(total) => `共${total}条`}
                    showQuickJumper
                    showSizeChanger
                  />
              }
            </div>
          </div>
        </AppDatasBody>
        <Detail
          visible={visible}
          onCancel={this.onCancel}
        />
        <EcodeApplyModal
          visible={ecodeVisible}
          onCancel={() => this.setState({ecodeVisible: false})}
          appId={appId}
        />
      </div>
    )
  }

}

export default App


// WEBPACK FOOTER //
// ./src/components/order/EcodeOrder.js